import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createVNode as _createVNode, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, withKeys as _withKeys, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, renderList as _renderList } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "toolbar-input-wrapper" }
const _hoisted_3 = ["aria-label"]
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = {
  key: 0,
  class: "row no-wrap q-py-xs q-px-md"
}
const _hoisted_6 = { class: "q-ml-sm" }
const _hoisted_7 = {
  key: 0,
  class: "full-height"
}
const _hoisted_8 = {
  class: "full-height",
  style: {"display":"flex","gap":"0"}
}
const _hoisted_9 = {
  key: 1,
  style: {"height":"100%","max-height":"100%","text-align":"center","padding-top":"20px"}
}
const _hoisted_10 = { class: "text-subtitle2" }
const _hoisted_11 = { class: "text-subtitle2" }
const _hoisted_12 = {
  key: 0,
  class: "q-mr-sm",
  style: {"word-wrap":"keep-all"}
}
const _hoisted_13 = {
  key: 1,
  class: "q-mr-sm",
  style: {"word-wrap":"keep-all"}
}
const _hoisted_14 = {
  key: 0,
  style: {"min-height":"100%","max-height":"100%","overflow":"hidden","display":"flex","flex-flow":"column"}
}
const _hoisted_15 = { class: "row bg-white no-wrap justify-between" }
const _hoisted_16 = ["disabled", "aria-label"]
const _hoisted_17 = { class: "q-py-xs text-bold" }
const _hoisted_18 = {
  key: 0,
  class: "q-py-xs text-bold"
}
const _hoisted_19 = {
  class: "row no-wrap full-width",
  style: {"border-bottom":"1px solid #eaeaea"}
}
const _hoisted_20 = { class: "q-py-xs" }
const _hoisted_21 = {
  key: 1,
  style: {"height":"100%","max-height":"100%","text-align":"center","padding-top":"20px"}
}
const _hoisted_22 = {
  key: 0,
  class: "row justify-between q-pa-sm no-wrap",
  style: 'width: 100%; min-width: 880px; background: white;'
}
const _hoisted_23 = { style: {"text-decoration":"underline !important"} }
const _hoisted_24 = { style: {"text-decoration":"underline !important"} }
const _hoisted_25 = { style: {"text-decoration":"underline !important"} }
const _hoisted_26 = {
  key: 1,
  style: {"width":"100%","flex":"1 1 0","min-height":"0"}
}
const _hoisted_27 = {
  key: 2,
  class: "q-mx-auto q-my-auto empty-label"
}
const _hoisted_28 = {
  key: 6,
  class: "q-mx-auto",
  style: {"width":"99%","height":"99%","position":"relative"}
}
const _hoisted_29 = {
  key: 1,
  class: "q-mx-auto q-my-auto empty-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_ContextMenuIcon = _resolveComponent("ContextMenuIcon")!
  const _component_mosta_context_menu = _resolveComponent("mosta-context-menu")!
  const _component_segment_selector = _resolveComponent("segment-selector")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_CustomDragLayer = _resolveComponent("CustomDragLayer")!
  const _component_virtual_analytics_list = _resolveComponent("virtual-analytics-list")!
  const _component_ConfirmActionPopup = _resolveComponent("ConfirmActionPopup")!
  const _component_DndProvider = _resolveComponent("DndProvider")!
  const _component_q_spinner_dots = _resolveComponent("q-spinner-dots")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_movement_create_component = _resolveComponent("movement-create-component")!
  const _component_item_addition_component = _resolveComponent("item-addition-component")!
  const _component_storages_edit_component = _resolveComponent("storages-edit-component")!
  const _component_project_data_component = _resolveComponent("project-data-component")!
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_projection_settings_panel = _resolveComponent("projection-settings-panel")!
  const _component_analytics_filter_list = _resolveComponent("analytics-filter-list")!
  const _component_base_chart_panel = _resolveComponent("base-chart-panel")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_report_element_settings_panel = _resolveComponent("report-element-settings-panel")!
  const _component_formulas_list = _resolveComponent("formulas-list")!
  const _component_element_options_settings_panel = _resolveComponent("element-options-settings-panel")!
  const _component_selected_settings_list = _resolveComponent("selected-settings-list")!
  const _component_analytics_settings_list = _resolveComponent("analytics-settings-list")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!
  const _component_q_splitter = _resolveComponent("q-splitter")!
  const _component_q_drawer = _resolveComponent("q-drawer")!
  const _component_QTLiteSkeleton = _resolveComponent("QTLiteSkeleton")!
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_toolbar = _resolveComponent("q-toolbar")!
  const _component_query_table = _resolveComponent("query-table")!
  const _component_query_chart = _resolveComponent("query-chart")!
  const _component_query_table_preview = _resolveComponent("query-table-preview")!
  const _component_query_chart_preview = _resolveComponent("query-chart-preview")!
  const _component_report_break_preview = _resolveComponent("report-break-preview")!
  const _component_q_layout = _resolveComponent("q-layout")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_layout, {
    view: "lHh Lpr lFf",
    class: _normalizeClass(['analytics-layout', { 'qlayout--clip': _ctx.clipPageScroll }]),
    onKeydown: _withKeys(_ctx.onEscKeydown, ["esc"])
  }, {
    default: _withCtx(() => [
      (_ctx.hasPageAccess)
        ? (_openBlock(), _createBlock(_component_q_splitter, {
            key: 0,
            modelValue: _ctx.splitterModel.outer,
            "onUpdate:modelValue": [
              _cache[41] || (_cache[41] = ($event: any) => ((_ctx.splitterModel.outer) = $event)),
              _ctx.onChange
            ],
            unit: "px",
            "emit-immediately": "",
            class: _normalizeClass(_ctx.splitterClass)
          }, {
            before: _withCtx(() => [
              _createVNode(_component_q_drawer, {
                modelValue: _ctx.leftDrawerOpen,
                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.leftDrawerOpen) = $event)),
                "show-if-above": "",
                bordered: "",
                class: "white",
                width: _ctx.drawerWidth,
                breakpoint: 0
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createElementVNode("div", {
                    class: _normalizeClass(["list-toolbar", { 'list-toolbar--search': _ctx.genstore.globalFilterMode }])
                  }, [
                    (_ctx.rootstore.generalMode < 100)
                      ? (_openBlock(), _createElementBlock("button", {
                          key: 0,
                          ref: "plus_menu_anchor",
                          class: _normalizeClass(["toolbar-icon-btn toolbar-icon-btn--accent toolbar-icon-btn--add", { 'toolbar-icon-btn--active-add': _ctx.plusMenuOpen }]),
                          "aria-label": _ctx.$t('create_root'),
                          onMouseenter: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openPlusMenu && _ctx.openPlusMenu(...args))),
                          onMouseleave: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onPlusButtonLeave && _ctx.onPlusButtonLeave(...args))),
                          onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.togglePlusMenu && _ctx.togglePlusMenu(...args)), ["stop"]))
                        }, [
                          _cache[42] || (_cache[42] = _createElementVNode("svg", {
                            width: "18",
                            height: "18",
                            viewBox: "0 0 18 18",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg"
                          }, [
                            _createElementVNode("path", {
                              d: "M16 8C16.5523 8 17 8.44772 17 9C17 9.55229 16.5523 10 16 10H2C1.44772 10 1 9.55229 1 9C1 8.44772 1.44772 8 2 8H16ZM9 1C9.55229 1 10 1.44772 10 2V16C10 16.5523 9.55229 17 9 17C8.44772 17 8 16.5523 8 16V2C8 1.44772 8.44772 1 9 1Z",
                              fill: "currentColor"
                            })
                          ], -1)),
                          (!_ctx.plusMenuOpen)
                            ? (_openBlock(), _createBlock(_component_q_tooltip, {
                                key: 0,
                                delay: 300,
                                anchor: "top middle",
                                self: "center middle"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t("create_root")), 1)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ], 42, _hoisted_1))
                      : _createCommentVNode("", true),
                    _createVNode(_component_mosta_context_menu, {
                      visible: _ctx.plusMenuOpen,
                      position: _ctx.plusMenuPos,
                      "min-width": 180,
                      "disable-backdrop-pointer": true,
                      "menu-class": "plus-context-menu",
                      onClose: _cache[8] || (_cache[8] = ($event: any) => (_ctx.plusMenuOpen = false)),
                      onMenuEnter: _ctx.onPlusMenuEnter,
                      onMenuLeave: _ctx.onPlusMenuLeave
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "plus-context-menu__item",
                          onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onPlusMenuCreateFolder && _ctx.onPlusMenuCreateFolder(...args)))
                        }, [
                          _createVNode(_component_ContextMenuIcon, {
                            src: _ctx.contextMenuIcons.Folder
                          }, null, 8, ["src"]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('create_folder')), 1)
                        ]),
                        _cache[44] || (_cache[44] = _createElementVNode("div", { class: "plus-context-menu__sep" }, null, -1)),
                        _createElementVNode("div", {
                          class: "plus-context-menu__item",
                          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onPlusMenuCreateSelection && _ctx.onPlusMenuCreateSelection(...args)))
                        }, [
                          _createVNode(_component_ContextMenuIcon, {
                            src: _ctx.contextMenuIcons.Selection
                          }, null, 8, ["src"]),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('create_selection')), 1)
                        ]),
                        (_ctx.canShowPlusChartItems)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _cache[43] || (_cache[43] = _createElementVNode("div", { class: "plus-context-menu__sep" }, null, -1)),
                              _createElementVNode("div", {
                                class: "plus-context-menu__item",
                                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onPlusMenuCreateChart(_ctx.chartMenuTypes.GRAPH)))
                              }, [
                                _createVNode(_component_ContextMenuIcon, {
                                  src: _ctx.contextMenuIcons.LinearChart
                                }, null, 8, ["src"]),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('add_linear_chart')), 1)
                              ]),
                              _createElementVNode("div", {
                                class: "plus-context-menu__item",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onPlusMenuCreateChart(_ctx.chartMenuTypes.PIE_CHART)))
                              }, [
                                _createVNode(_component_ContextMenuIcon, {
                                  src: _ctx.contextMenuIcons.PieChart
                                }, null, 8, ["src"]),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('add_pie_chart')), 1)
                              ]),
                              _createElementVNode("div", {
                                class: "plus-context-menu__item",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.onPlusMenuCreateChart(_ctx.chartMenuTypes.BAR_CHART)))
                              }, [
                                _createVNode(_component_ContextMenuIcon, {
                                  src: _ctx.contextMenuIcons.BarChart
                                }, null, 8, ["src"]),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('add_bar_chart')), 1)
                              ])
                            ], 64))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1,
                      __: [44]
                    }, 8, ["visible", "position", "onMenuEnter", "onMenuLeave"]),
                    _createElementVNode("div", _hoisted_2, [
                      _withDirectives(_createVNode(_component_segment_selector, {
                        class: "full-width toolbar-segment-selector",
                        mode: _ctx.rootstore.generalMode,
                        data: _ctx.rootstore.generalSelector,
                        onChange: _ctx.changeMode
                      }, null, 8, ["mode", "data", "onChange"]), [
                        [_vShow, !_ctx.genstore.globalFilterMode]
                      ]),
                      _withDirectives(_createVNode(_component_q_input, {
                        "hide-bottom-space": "",
                        outlined: "",
                        dense: "",
                        color: "white",
                        ref: "panel_search_input",
                        autofocus: "",
                        onKeydown: _cache[9] || (_cache[9] = _withKeys(($event: any) => {
                  _ctx.genstore.setGlobalFilterMode(false);
                  _ctx.filter_string = '';
                }, ["esc"])),
                        class: "full-width toolbar-search-input",
                        modelValue: _ctx.filter_string,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.filter_string) = $event)),
                        debounce: "150",
                        clearable: "",
                        "clear-icon": _ctx.clearIconName
                      }, null, 8, ["modelValue", "clear-icon"]), [
                        [_vShow, _ctx.genstore.globalFilterMode]
                      ])
                    ]),
                    _createElementVNode("button", {
                      class: _normalizeClass(["toolbar-icon-btn toolbar-icon-btn--accent toolbar-icon-btn--search", { 'toolbar-icon-btn--active-search': _ctx.genstore.globalFilterMode }]),
                      onClick: _cache[11] || (_cache[11] = ($event: any) => {_ctx.genstore.setGlobalFilterMode(!_ctx.genstore.globalFilterMode); _ctx.focusSearch()}),
                      "aria-label": _ctx.$t('filter')
                    }, [
                      _cache[45] || (_cache[45] = _createElementVNode("svg", {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M17.5005 17.5L13.8838 13.8833",
                          stroke: "currentColor",
                          "stroke-width": "1.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        }),
                        _createElementVNode("path", {
                          d: "M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z",
                          stroke: "currentColor",
                          "stroke-width": "1.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        })
                      ], -1)),
                      _createVNode(_component_q_tooltip, {
                        delay: 300,
                        anchor: "top middle",
                        self: "center middle"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('search_short')), 1)
                        ]),
                        _: 1
                      })
                    ], 10, _hoisted_3),
                    _createElementVNode("button", {
                      class: _normalizeClass(["toolbar-icon-btn toolbar-icon-btn--accent toolbar-icon-btn--fav", { 'toolbar-icon-btn--active-fav': _ctx.genstore.favoriteMode }]),
                      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.genstore.setFavoriteFilterMode(!_ctx.genstore.favoriteMode))),
                      "aria-label": _ctx.$t('favorite')
                    }, [
                      _cache[46] || (_cache[46] = _createElementVNode("svg", {
                        width: "18",
                        height: "18",
                        viewBox: "29.5 2.5 16.5 14.5",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("path", {
                          d: "M30.7773 7.83935C30.7774 7.03566 31.0212 6.25088 31.4765 5.58866C31.9319 4.92645 32.5775 4.41794 33.3279 4.13031C34.0784 3.84268 34.8984 3.78946 35.6798 3.97767C36.4611 4.16588 37.167 4.58667 37.7042 5.18446C37.742 5.22492 37.7877 5.25717 37.8385 5.27922C37.8894 5.30127 37.9442 5.31265 37.9995 5.31265C38.0549 5.31265 38.1097 5.30127 38.1605 5.27922C38.2114 5.25717 38.2571 5.22492 38.2949 5.18446C38.8304 4.58278 39.5364 4.15846 40.319 3.96796C41.1017 3.77746 41.9237 3.82983 42.6758 4.11809C43.4279 4.40636 44.0744 4.91685 44.5292 5.58161C44.984 6.24638 45.2256 7.0339 45.2217 7.83935C45.2217 9.49323 44.1384 10.7282 43.0551 11.8116L39.0887 15.6487C38.9541 15.8033 38.7882 15.9274 38.6019 16.0129C38.4157 16.0984 38.2134 16.1433 38.0084 16.1446C37.8035 16.1459 37.6006 16.1036 37.4133 16.0205C37.226 15.9373 37.0585 15.8153 36.922 15.6624L32.944 11.8116C31.8607 10.7282 30.7773 9.50045 30.7773 7.83935Z",
                          stroke: "currentColor",
                          "stroke-width": "1.5",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round"
                        })
                      ], -1)),
                      _createVNode(_component_q_tooltip, {
                        delay: 300,
                        anchor: "top middle",
                        self: "center middle"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t("favorite")), 1)
                        ]),
                        _: 1
                      })
                    ], 10, _hoisted_4),
                    _createElementVNode("button", {
                      class: "toolbar-icon-btn toolbar-icon-btn--expand",
                      onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.setUpperExpand(!_ctx.upperExpand)))
                    }, [
                      (_openBlock(), _createElementBlock("svg", {
                        width: "9",
                        height: "6",
                        viewBox: "0 0 9 6",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                        style: _normalizeStyle(_ctx.upperExpand ? 'transform: rotate(180deg)' : '')
                      }, _cache[47] || (_cache[47] = [
                        _createElementVNode("path", {
                          d: "M4.33008 5.25L8.66021 0H-4.91142e-05L4.33008 5.25Z",
                          fill: "currentColor"
                        }, null, -1)
                      ]), 4))
                    ])
                  ], 2), [
                    [_vShow, !_ctx.bottomExpand]
                  ]),
                  (
              _ctx.bottomExpand && _ctx.genstore.selectedItem && _ctx.genstore.selectedItem.Id
            )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        (_ctx.genstore.selectedItem && _ctx.genstore.selectedItem.elType === 0)
                          ? (_openBlock(), _createBlock(_component_q_icon, {
                              key: 0,
                              color: "accent",
                              name: "grid_view",
                              style: {"margin-right":"1px"},
                              size: "xs"
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.genstore.selectedItem && _ctx.genstore.selectedItem.elType === 1)
                          ? (_openBlock(), _createBlock(_component_q_icon, {
                              key: 1,
                              color: "accent",
                              name: "",
                              style: {"margin-right":"3px","margin-top":"4px"},
                              size: "xs"
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.genstore.selectedItem && _ctx.genstore.selectedItem.elType === 2)
                          ? (_openBlock(), _createBlock(_component_q_icon, {
                              key: 2,
                              color: "accent",
                              name: "show_chart",
                              style: {"margin-right":"3px","margin-top":"4px"},
                              size: "xs"
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.genstore.selectedItem && _ctx.genstore.selectedItem.elType === 3)
                          ? (_openBlock(), _createBlock(_component_q_icon, {
                              key: 3,
                              color: "accent",
                              name: "pie_chart_outline",
                              style: {"margin-right":"3px","margin-top":"4px"},
                              size: "xs"
                            }))
                          : _createCommentVNode("", true),
                        (_ctx.genstore.selectedItem && _ctx.genstore.selectedItem.elType === 4)
                          ? (_openBlock(), _createBlock(_component_q_icon, {
                              key: 4,
                              color: "accent",
                              name: "bar_chart",
                              style: {"margin-right":"3px","margin-top":"4px"},
                              size: "xs"
                            }))
                          : _createCommentVNode("", true),
                        (
                _ctx.genstore.selectedItem && _ctx.genstore.selectedItem.elType === 901
              )
                          ? (_openBlock(), _createBlock(_component_q_icon, {
                              key: 5,
                              color: "accend",
                              name: "height",
                              style: {"margin-right":"3px","margin-top":"4px"},
                              size: "xs"
                            }))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.genstore.selectedItem ? _ctx.genstore.selectedItem.CombinedName : ""), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_component_q_splitter, {
                    modelValue: _ctx.splitterModel.inner,
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.splitterModel.inner) = $event)),
                    limits: [0, 100],
                    style: _normalizeStyle(`height: calc(100% - ${
              _ctx.bottomExpand ? 37 : _ctx.upperExpand ? 63 : 62
            }px);`),
                    horizontal: ""
                  }, {
                    before: _withCtx(() => [
                      (!_ctx.genstore.isLoading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _createVNode(_component_DndProvider, {
                              backend: _ctx.TouchBackend,
                              options: _ctx.dndBackendOptions,
                              context: _ctx.DND_CONTEXT
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_CustomDragLayer, {
                                  "selected-items": _ctx.$refs.virtualListRef?.selectedItems,
                                  "flat-items": _ctx.$refs.virtualListRef?.flatItems,
                                  "effective-count": _ctx.$refs.virtualListRef?.effectiveSelectedCount
                                }, null, 8, ["selected-items", "flat-items", "effective-count"]),
                                _createElementVNode("div", _hoisted_8, [
                                  _createVNode(_component_virtual_analytics_list, {
                                    ref: "virtualListRef",
                                    style: {"flex":"1","min-width":"0","border-left":"1px solid #e0e0e0"},
                                    "input-items": _ctx.currentInputItems,
                                    "search-string": _ctx.filter_string,
                                    "favorite-mode": _ctx.genstore.favoriteMode,
                                    "pending-create-folder-by-parent": _ctx.pendingCreateFolderByParent,
                                    "pending-move-by-key": _ctx.pendingMoveByKey,
                                    "between-root-drop-via-indicator": true,
                                    "back-enabled": _ctx.historystore.canGoBack,
                                    onBack: _ctx.goBackToPreviousElement,
                                    onChangeParent: _ctx.moveItemToParent,
                                    onCardSelected: _ctx.onItemSelected,
                                    onCardDeleted: _ctx.onRequestItemDelete,
                                    onCardFavorite: _ctx.onItemFavorite,
                                    onCardCloned: _ctx.onItemCloned,
                                    onCardRenamed: _ctx.onItemRenamed,
                                    onAddChildSelection: _ctx.addChildSelection,
                                    onAddChildProjection: _ctx.addChildProjection,
                                    onAddChildList: _ctx.openCreateList,
                                    onAddChildChart: _ctx.addChildChart,
                                    onAddChildFolder: _ctx.addChildFolder,
                                    onAddToReport: _ctx.openAddToReport,
                                    onDeleteSelected: _ctx.onDeleteSelected,
                                    onBreakAfter: _ctx.onBreakAfter,
                                    onChangePosition: _ctx.moveStoreItem,
                                    onCardMoved: _ctx.moveCard
                                  }, null, 8, ["input-items", "search-string", "favorite-mode", "pending-create-folder-by-parent", "pending-move-by-key", "back-enabled", "onBack", "onChangeParent", "onCardSelected", "onCardDeleted", "onCardFavorite", "onCardCloned", "onCardRenamed", "onAddChildSelection", "onAddChildProjection", "onAddChildList", "onAddChildChart", "onAddChildFolder", "onAddToReport", "onDeleteSelected", "onBreakAfter", "onChangePosition", "onCardMoved"])
                                ]),
                                (_ctx.confirmPopup.show)
                                  ? (_openBlock(), _createBlock(_component_ConfirmActionPopup, {
                                      key: 0,
                                      title: _ctx.confirmPopup.title,
                                      question: _ctx.confirmPopup.question,
                                      highlight: _ctx.confirmPopup.highlight,
                                      "question-html": _ctx.confirmPopup.questionHtml,
                                      position: _ctx.confirmPopup.position,
                                      "confirm-label": _ctx.confirmPopup.confirmLabel,
                                      "cancel-label": _ctx.confirmPopup.cancelLabel,
                                      onConfirm: _ctx.confirmPopup.onConfirm,
                                      onCancel: _ctx.confirmPopup.onCancel
                                    }, null, 8, ["title", "question", "highlight", "question-html", "position", "confirm-label", "cancel-label", "onConfirm", "onCancel"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            }, 8, ["backend", "options", "context"])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createVNode(_component_q_spinner_dots, {
                              color: "primary",
                              size: "2em"
                            })
                          ])),
                      _createVNode(_component_q_dialog, {
                        modelValue: _ctx.addToReportDialog,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.addToReportDialog) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_card, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_card_section, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("select_report")), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_q_separator),
                              _createVNode(_component_q_card_section, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_select, {
                                    flat: "",
                                    modelValue: _ctx.reportIdsModel,
                                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.reportIdsModel) = $event)),
                                    multiple: "",
                                    outlined: "",
                                    "option-label": "Name",
                                    "option-value": "Id",
                                    label: 
                        _ctx.reportIdsModel.length ? '' : _ctx.$t('create_report_and_add')
                      ,
                                    options: _ctx.reportOptions
                                  }, {
                                    "no-option": _withCtx(() => [
                                      _createVNode(_component_q_item, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_q_item_section, { class: "text-grey" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.$t("no_data_found")), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["modelValue", "label", "options"])
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_q_separator),
                              _createVNode(_component_q_card_actions, { align: "right" }, {
                                default: _withCtx(() => [
                                  _withDirectives(_createVNode(_component_q_btn, {
                                    flat: "",
                                    size: "sm",
                                    label: _ctx.$t('cancel'),
                                    color: "dark"
                                  }, null, 8, ["label"]), [
                                    [_directive_close_popup]
                                  ]),
                                  _withDirectives(_createVNode(_component_q_btn, {
                                    flat: "",
                                    size: "sm",
                                    label: _ctx.$t('do_action'),
                                    onClick: _ctx.addToReport,
                                    autofocus: "",
                                    color: "dark"
                                  }, null, 8, ["label", "onClick"]), [
                                    [_directive_close_popup]
                                  ])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_q_dialog, {
                        modelValue: _ctx.createListDialog,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.createListDialog) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_card, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_q_card_section, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("create_list")), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_q_separator),
                              _createVNode(_component_q_card_section, null, {
                                default: _withCtx(() => [
                                  (_ctx.genstore.isLoading)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.$t("precalculation")), 1))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.$t("create_list_promt_1")) + "  " + _toDisplayString(_ctx.genstore.getPrecalcCount) + " " + _toDisplayString([0, 6].includes(_ctx.tempListBase.hoverParams.elType)
                          ? _ctx.$t("create_list_promt_2_sel")
                          : _ctx.$t("create_list_promt_2_proj")) + "? ", 1))
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_q_separator),
                              (!_ctx.genstore.isLoading && _ctx.genstore.getPrecalcCount)
                                ? (_openBlock(), _createBlock(_component_q_card_actions, {
                                    key: 0,
                                    align: "right"
                                  }, {
                                    default: _withCtx(() => [
                                      _withDirectives(_createVNode(_component_q_btn, {
                                        flat: "",
                                        size: "sm",
                                        label: _ctx.$t('cancel'),
                                        color: "dark"
                                      }, null, 8, ["label"]), [
                                        [_directive_close_popup]
                                      ]),
                                      _withDirectives(_createVNode(_component_q_btn, {
                                        flat: "",
                                        size: "sm",
                                        label: _ctx.$t('do_action'),
                                        onClick: _ctx.addChildList,
                                        color: "dark",
                                        autofocus: ""
                                      }, null, 8, ["label", "onClick"]), [
                                        [_directive_close_popup]
                                      ])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_q_dialog, {
                        modelValue: _ctx.createMovementMode,
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.createMovementMode) = $event)),
                        persistent: "",
                        "no-shake": "",
                        "full-width": true
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_movement_create_component, {
                            "create-type": _ctx.createMoveType,
                            onClose: _cache[17] || (_cache[17] = ($event: any) => (_ctx.createMovementMode = false)),
                            "container-for-preload": _ctx.containerForNewMovement
                          }, null, 8, ["create-type", "container-for-preload"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_q_dialog, {
                        modelValue: _ctx.createStorageItemMode,
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.createStorageItemMode) = $event)),
                        "no-shake": "",
                        "full-width": false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_item_addition_component, {
                            onClose: _cache[19] || (_cache[19] = ($event: any) => (_ctx.createStorageItemMode = false))
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_q_dialog, {
                        modelValue: _ctx.editStoragesMode,
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.editStoragesMode) = $event)),
                        "no-shake": "",
                        "full-width": false
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_storages_edit_component, {
                            onClose: _cache[21] || (_cache[21] = ($event: any) => (_ctx.editStoragesMode = false))
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"]),
                      _createVNode(_component_q_dialog, {
                        modelValue: _ctx.editFinancesMode,
                        "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.editFinancesMode) = $event)),
                        persistent: "",
                        "no-shake": "",
                        "full-width": true
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_project_data_component, {
                            onClose: _cache[23] || (_cache[23] = ($event: any) => (_ctx.editFinancesMode = false))
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    after: _withCtx(() => [
                      (!_ctx.setstore.isLoading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                            _withDirectives(_createElementVNode("div", _hoisted_15, [
                              _createVNode(_component_q_tabs, {
                                modelValue: _ctx.tab,
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.tab) = $event)),
                                dense: "",
                                class: "analytics-tabs bg-white",
                                align: "justify"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_q_tab, {
                                    name: "filters",
                                    "no-caps": "",
                                    label: _ctx.$t('settings'),
                                    ripple: false
                                  }, null, 8, ["label"]),
                                  _createVNode(_component_q_tab, {
                                    name: "columns",
                                    "no-caps": "",
                                    label: _ctx.$t('appearance'),
                                    ripple: false
                                  }, null, 8, ["label"])
                                ]),
                                _: 1
                              }, 8, ["modelValue"]),
                              _createVNode(_component_q_space),
                              (
                      _ctx.genstore.selectedItem &&
                      _ctx.genstore.selectedItem.Id &&
                      [0, 1, 6].includes(_ctx.genstore.selectedItem.elType) &&
                      _ctx.tab === 'filters'
                    )
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "toolbar-icon-btn toolbar-icon-btn--accent",
                                    style: {"padding":"0 6px","margin-right":"2px"},
                                    disabled: _ctx.setstore.isSaving || _ctx.querystore.isLoading,
                                    "aria-label": _ctx.$t('clear_filter'),
                                    onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.resetAllFilters && _ctx.resetAllFilters(...args)))
                                  }, [
                                    _cache[48] || (_cache[48] = _createElementVNode("svg", {
                                      width: "18",
                                      height: "18",
                                      viewBox: "0 0 18 18",
                                      fill: "none",
                                      xmlns: "http://www.w3.org/2000/svg"
                                    }, [
                                      _createElementVNode("path", {
                                        d: "M9 14.25L3.75 9L9 3.75",
                                        stroke: "currentColor",
                                        "stroke-width": "1.6875",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round"
                                      }),
                                      _createElementVNode("path", {
                                        d: "M14.25 9H3.75",
                                        stroke: "currentColor",
                                        "stroke-width": "1.6875",
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round"
                                      })
                                    ], -1)),
                                    _createVNode(_component_q_tooltip, {
                                      delay: 300,
                                      anchor: "top middle",
                                      self: "center middle"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('clear_filter')), 1)
                                      ]),
                                      _: 1
                                    })
                                  ], 8, _hoisted_16))
                                : _createCommentVNode("", true),
                              (_ctx.genstore.selectedItem && _ctx.genstore.selectedItem.Id)
                                ? (_openBlock(), _createBlock(_component_q_btn, {
                                    key: 1,
                                    disable: 
                      _ctx.setstore.isSaving ||
                      _ctx.graphstore.isSaving ||
                      _ctx.querystore.isLoading ||
                      _ctx.filtersIncorrect ||
                      _ctx.chartsIncorrect
                    ,
                                    class: "q-my-none splitter-refresh-btn",
                                    flat: "",
                                    dense: "",
                                    round: "",
                                    icon: "refresh",
                                    size: "md",
                                    color: "grey-6",
                                    onClick: _ctx.getQueryResult,
                                    "aria-label": _ctx.$t('result')
                                  }, {
                                    default: _withCtx(() => [
                                      (
                        _ctx.setstore.isSaving ||
                        _ctx.graphstore.isSaving ||
                        _ctx.querystore.isLoading ||
                        _ctx.filtersIncorrect ||
                        _ctx.chartsIncorrect
                      )
                                        ? (_openBlock(), _createBlock(_component_q_tooltip, {
                                            key: 0,
                                            delay: 300,
                                            anchor: "top middle",
                                            self: "center middle"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.setstore.isSaving ||
                        _ctx.graphstore.isSaving ||
                        _ctx.querystore.isLoading
                          ? _ctx.$t("loading")
                          : _ctx.filtersIncorrect || _ctx.chartsIncorrect
                          ? _ctx.$t("filters_error_fix_before_update")
                          : _ctx.$t("unavailable")), 1)
                                            ]),
                                            _: 1
                                          }))
                                        : (_openBlock(), _createBlock(_component_q_tooltip, {
                                            key: 1,
                                            delay: 300,
                                            anchor: "top middle",
                                            self: "center middle"
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.$t('refresh_label')), 1)
                                            ]),
                                            _: 1
                                          }))
                                    ]),
                                    _: 1
                                  }, 8, ["disable", "onClick", "aria-label"]))
                                : _createCommentVNode("", true),
                              _createElementVNode("button", {
                                class: "toolbar-icon-btn toolbar-icon-btn--splitter-expand",
                                style: {"padding":"0 10px"},
                                onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.setBottomExpand(!_ctx.bottomExpand)))
                              }, [
                                (_openBlock(), _createElementBlock("svg", {
                                  width: "9",
                                  height: "6",
                                  viewBox: "0 0 9 6",
                                  fill: "none",
                                  xmlns: "http://www.w3.org/2000/svg",
                                  style: _normalizeStyle(_ctx.bottomExpand ? '' : 'transform: rotate(180deg)')
                                }, _cache[49] || (_cache[49] = [
                                  _createElementVNode("path", {
                                    d: "M4.33008 5.25L8.66021 0H-4.91142e-05L4.33008 5.25Z",
                                    fill: "currentColor"
                                  }, null, -1)
                                ]), 4))
                              ])
                            ], 512), [
                              [_vShow, !_ctx.upperExpand]
                            ]),
                            _createVNode(_component_q_separator),
                            _createVNode(_component_q_tab_panels, {
                              modelValue: _ctx.tab,
                              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.tab) = $event)),
                              class: "full-height bg-white scroll q-pa-xs settings-panels-scroll"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_q_tab_panel, {
                                  name: "filters",
                                  class: "left-panel bg-white full-height q-pa-xs"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_projection_settings_panel, {
                                      element: _ctx.genstore.selectedItem,
                                      "parent-chain": _ctx.setstore.getProjectionParentChain,
                                      "model-value": _ctx.setstore.getProjectionRolesFilter
                                    }, null, 8, ["element", "parent-chain", "model-value"]),
                                    (_ctx.setstore.hasProjectionOwnFilters)
                                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                          _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("projection_own_filters")), 1),
                                          _createVNode(_component_analytics_filter_list, {
                                            "input-items": _ctx.setstore.getProjectionFilters,
                                            "exclude-descriptors": [
                          _ctx.filterGroupDescriptors.ProjectionRoles,
                        ],
                                            "owner-identity": _ctx.setstore.getProjectionOwnFiltersOwner
                                          }, null, 8, ["input-items", "exclude-descriptors", "owner-identity"]),
                                          (_ctx.setstore.getCurrentFiltersOwner)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_18, _toDisplayString(_ctx.$t("projection_parent_filters", {
                            name: _ctx.setstore.getProjectionParentChain[0].Name,
                          })), 1))
                                            : _createCommentVNode("", true)
                                        ], 64))
                                      : _createCommentVNode("", true),
                                    (
                        _ctx.graphstore?.getCurrentSettings && 
                        (_ctx.genstore.selectedItem.elType === 2 ||
                        _ctx.genstore.selectedItem.elType === 3 ||
                        _ctx.genstore.selectedItem.elType === 4)
                      )
                                      ? (_openBlock(), _createBlock(_component_base_chart_panel, {
                                          key: 'graph_'+_ctx.genstore.selectedItem.Id+'_'+_ctx.genstore.selectedItem.elType+'_'+_ctx.graphstore.getCurrentSettings?.Descriptor,
                                          modelValue: _ctx.graphstore.getCurrentSettings,
                                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.graphstore.getCurrentSettings) = $event))
                                        }, null, 8, ["modelValue"]))
                                      : (_ctx.setstore.getCurrentFiltersOwner)
                                        ? (_openBlock(), _createBlock(_component_analytics_filter_list, {
                                            key: 2,
                                            "input-items": _ctx.setstore.getCurrentFilters,
                                            "owner-identity": _ctx.setstore.getCurrentFiltersOwner
                                          }, null, 8, ["input-items", "owner-identity"]))
                                        : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_q_tab_panel, {
                                  ref: "bottom_scroll_panel",
                                  name: "columns",
                                  class: "left-panel bg-white full-height",
                                  style: {"overflow-x":"hidden"}
                                }, {
                                  default: _withCtx(() => [
                                    (
                        _ctx.genstore.selectedItem &&
                        _ctx.genstore.selectedItem.ElementId &&
                        _ctx.genstore.selectedItem.elType !== 901
                      )
                                      ? (_openBlock(), _createBlock(_component_report_element_settings_panel, {
                                          key: 0,
                                          "model-value": _ctx.genstore.selectedItem
                                        }, null, 8, ["model-value"]))
                                      : _createCommentVNode("", true),
                                    (
                        _ctx.setstore.getSelectedColumns &&
                        _ctx.genstore.selectedItem &&
                        [0, 1].includes(_ctx.genstore.selectedItem.DestType) &&
                        ![2, 3, 4].includes(_ctx.genstore.selectedItem.elType)
                      )
                                      ? (_openBlock(), _createBlock(_component_formulas_list, {
                                          key: 1,
                                          modelValue: _ctx.setstore.tableFormulas,
                                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.setstore.tableFormulas) = $event)),
                                          "parameter-options": _ctx.graphstore.getCurrentFormulas,
                                          "nested-key-name": "ChildFormulas",
                                          "template-name": "Entity",
                                          onChangePosition: _ctx.moveFormulaItem
                                        }, null, 8, ["modelValue", "parameter-options", "onChangePosition"]))
                                      : _createCommentVNode("", true),
                                    (
                        _ctx.setstore.getProjectionOptions &&
                        _ctx.setstore.getProjectionOptions.length &&
                        ![2, 3, 4].includes(_ctx.genstore.selectedItem.elType)
                      )
                                      ? (_openBlock(), _createBlock(_component_element_options_settings_panel, {
                                          key: 2,
                                          modelValue: _ctx.setstore.getProjectionOptions,
                                          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.setstore.getProjectionOptions) = $event))
                                        }, null, 8, ["modelValue"]))
                                      : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_19, [
                                      _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t("columns_header")), 1),
                                      _createVNode(_component_q_space),
                                      (_ctx.setstore.getSelectedColumns && _ctx.tab === 'columns')
                                        ? (_openBlock(), _createBlock(_component_q_btn, {
                                            key: 0,
                                            disable: 
                          !_ctx.groupMode || _ctx.compound_ids.length > 1 ? false : true
                        ,
                                            class: "q-mt-none q-mb-xs",
                                            flat: "",
                                            dense: "",
                                            "no-caps": "",
                                            color: "grey-6",
                                            onClick: _ctx.onGroupClick,
                                            "aria-label": _ctx.$t('combining')
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(!_ctx.groupMode ? _ctx.$t("combining") : _ctx.$t("combine")), 1)
                                            ]),
                                            _: 1
                                          }, 8, ["disable", "onClick", "aria-label"]))
                                        : _createCommentVNode("", true),
                                      (
                          _ctx.setstore.getSelectedColumns &&
                          _ctx.groupMode &&
                          _ctx.tab === 'columns'
                        )
                                        ? (_openBlock(), _createBlock(_component_q_btn, {
                                            key: 1,
                                            class: "q-mt-none q-mb-xs",
                                            flat: "",
                                            dense: "",
                                            "no-caps": "",
                                            color: "grey-6",
                                            onClick: _ctx.onCancelGroupClick,
                                            "aria-label": _ctx.$t('cancel')
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.$t("cancel")), 1)
                                            ]),
                                            _: 1
                                          }, 8, ["onClick", "aria-label"]))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createVNode(_component_selected_settings_list, {
                                      "input-items": _ctx.setstore.getSelectedColumns,
                                      onChangePosition: _ctx.moveColumnItem,
                                      onChangeSelection: _ctx.onColumnSelected,
                                      onGroupChange: _ctx.addToGroup,
                                      onTogglesChange: _ctx.onTogglesChange,
                                      onRangeChange: _ctx.onRangeChange,
                                      onUnGroupClick: _ctx.onUnGroupClick,
                                      onUnGroupSingleClick: _ctx.onUnGroupSingleClick,
                                      groupingMode: _ctx.groupMode
                                    }, null, 8, ["input-items", "onChangePosition", "onChangeSelection", "onGroupChange", "onTogglesChange", "onRangeChange", "onUnGroupClick", "onUnGroupSingleClick", "groupingMode"]),
                                    _createVNode(_component_analytics_settings_list, {
                                      "input-items": _ctx.setstore.getNonSelectedColumns,
                                      onChangeSelection: _ctx.onColumnSelected
                                    }, null, 8, ["input-items", "onChangeSelection"]),
                                    (this.genstore.selectedItem && this.genstore.selectedItem.Id)
                                      ? (_openBlock(), _createBlock(_component_q_btn, {
                                          key: 3,
                                          flat: "",
                                          class: "q-mt-sm",
                                          size: "sm",
                                          label: _ctx.$t('make_default_settings'),
                                          color: "dark",
                                          onClick: _ctx.setDefSettingsClick
                                        }, null, 8, ["label", "onClick"]))
                                      : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                }, 512)
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createVNode(_component_q_spinner_dots, {
                              color: "primary",
                              size: "2em"
                            })
                          ]))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "style"])
                ]),
                _: 1
              }, 8, ["modelValue", "width"])
            ]),
            separator: _withCtx(() => [
              _createVNode(_component_q_btn, {
                flat: "",
                dense: "",
                round: "",
                style: {"position":"relative","right":"6px","top":"50vh","color":"grey","background-color":"white","transform":"rotate(90deg) translateY(12px)","width":"10px","height":"20px","border":"1px solid lightgrey","border-radius":"1px"},
                onClick: _ctx.drawerButtonClick,
                icon: _ctx.leftDrawerOpen ? 'arrow_drop_down' : 'arrow_drop_up',
                size: "sm"
              }, null, 8, ["onClick", "icon"])
            ]),
            after: _withCtx(() => [
              _createElementVNode("div", {
                class: "analytics-page-container",
                style: _normalizeStyle(_ctx.compPadding)
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass(["analytics-page", { 'qpage--table-flex': (_ctx.querystore.getCurrentTable && _ctx.querystore.getCurrentTable.HeaderRow) || _ctx.showTableSkeleton, 'qpage--clip': _ctx.clipPageScroll }]),
                  style: _normalizeStyle(`padding: 6px; background: ${
              (_ctx.querystore.getCurrentTable && _ctx.querystore.getCurrentTable.HeaderRow) || _ctx.showTableSkeleton ? '#F2F2F2' : '#fff'
            };`)
                }, [
                  ([7, 8].includes(_ctx.rootstore.generalMode))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createElementVNode("div", {
                          class: _normalizeClass(!_ctx.StorageWA ? 'text-h8 text-grey-6' : 'text-h8 cursor-pointer'),
                          style: {"text-decoration":"underline !important"},
                          onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.StorageWA && (_ctx.createStorageItemMode = true)))
                        }, _toDisplayString(_ctx.$t('add_warehouse_position')), 3),
                        _createElementVNode("div", {
                          class: _normalizeClass((!_ctx.StorageWA ? 'text-grey-6' : 'cursor-pointer')+' text-h8 no-break movement-element movement-element--income'),
                          onClick: _cache[35] || (_cache[35] = 
                  () => {
                    if (!_ctx.StorageWA) { return }
                    _ctx.createMoveType = 0;
                    if (!_ctx.containerForNewMovement || (_ctx.containerForNewMovement && _ctx.selectedCount <= 500)) {
                      _ctx.createMovementMode = true;
                    } else {
                      _ctx.alert(_ctx.$t('movement_max_positions'))
                    }
                  }
                )
                        }, [
                          _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('income_label')), 1)
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass((!_ctx.StorageWA ? 'text-grey-6' : 'cursor-pointer')+' text-h8 no-break movement-element movement-element--expense'),
                          onClick: _cache[36] || (_cache[36] = 
                  () => {
                    if (!_ctx.StorageWA) { return }
                    
                    _ctx.createMoveType = 1;
                    if (!_ctx.containerForNewMovement || (_ctx.containerForNewMovement && _ctx.selectedCount <= 500)) {
                      _ctx.createMovementMode = true;
                    } else {
                      _ctx.alert(_ctx.$t('movement_max_positions'))
                    }
                  }
                )
                        }, [
                          _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.$t('expense_label')), 1)
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass((!_ctx.StorageWA ? 'text-grey-6' : 'cursor-pointer')+' text-h8 no-break movement-element movement-element--transfer'),
                          onClick: _cache[37] || (_cache[37] = 
                  () => {
                    if (!_ctx.StorageWA) { return }

                    _ctx.createMoveType = 2;
                    if (!_ctx.containerForNewMovement || (_ctx.containerForNewMovement && _ctx.selectedCount <= 500)) {
                      _ctx.createMovementMode = true;
                    } else {
                      _ctx.alert(_ctx.$t('movement_max_positions'))
                    }
                  }
                )
                        }, [
                          _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('transfer_label')), 1)
                        ], 2),
                        _createElementVNode("div", {
                          class: _normalizeClass(!_ctx.StorageWA ? 'text-h8 text-grey-6' : 'text-h8 cursor-pointer'),
                          style: {"text-decoration":"underline !important"},
                          onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.StorageWA && (_ctx.editStoragesMode = true)))
                        }, _toDisplayString(_ctx.$t('edit_warehouses')), 3)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.showTableSkeleton)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        _createVNode(_component_QTLiteSkeleton)
                      ]))
                    : _createCommentVNode("", true),
                  (
                !_ctx.switchingElement &&
                !_ctx.querystore.isLoading &&
                !(
                  _ctx.querystore.getCurrentGraph &&
                  (_ctx.querystore.getCurrentGraph.CurveResults ||
                    _ctx.querystore.getCurrentGraph.BarChartResults ||
                    _ctx.querystore.getCurrentGraph.PieChartResults)
                ) &&
                !(
                  _ctx.querystore.getCurrentTable &&
                  _ctx.querystore.getCurrentTable.HeaderRow
                ) &&
                !(
                  _ctx.querystore.getCurrentReport &&
                  _ctx.querystore.getCurrentReport.length
                )
              )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_27, _toDisplayString(_ctx.$t("analytics_header")), 1))
                    : _createCommentVNode("", true),
                  false
                    ? (_openBlock(), _createBlock(_component_q_toolbar, { key: 3 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_btn, {
                            flat: "",
                            dense: "",
                            round: "",
                            onClick: _ctx.drawerButtonClick,
                            "aria-label": "Menu",
                            icon: "menu"
                          }, null, 8, ["onClick"]),
                          _createVNode(_component_q_toolbar_title, null, {
                            default: _withCtx(() => _cache[50] || (_cache[50] = [
                              _createTextVNode(" Quasar App ")
                            ])),
                            _: 1,
                            __: [50]
                          }),
                          _createElementVNode("div", null, "Quasar v" + _toDisplayString(_ctx.$q.version), 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (
                _ctx.querystore.getCurrentTable &&
                _ctx.querystore.getCurrentTable.HeaderRow
              )
                    ? _withDirectives((_openBlock(), _createBlock(_component_query_table, {
                        key: 4,
                        modelValue: _ctx.querystore.getCurrentTable,
                        "onUpdate:modelValue": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.querystore.getCurrentTable) = $event)),
                        "src-element": _ctx.genstore.selectedItem,
                        paginationModel: _ctx.pagination,
                        "onUpdate:paginationModel": _ctx.onUpdatePagination,
                        selectedEverything: _ctx.selectedAll,
                        "onUpdate:selectedEverything": _ctx.onSelectedAllUpdate,
                        selectedEntities: _ctx.selectedEntities,
                        "onUpdate:selectedEntities": _ctx.onSelectionUpdate,
                        unselectedEntities: _ctx.unselectedEntities,
                        "onUpdate:unselectedEntities": _ctx.onUnSelectionUpdate,
                        onSelectionChangeManual: _ctx.updatePinned,
                        onRefreshPage: _ctx.onRefreshTable,
                        onReloadTable: _ctx.getQueryResult
                      }, null, 8, ["modelValue", "src-element", "paginationModel", "onUpdate:paginationModel", "selectedEverything", "onUpdate:selectedEverything", "selectedEntities", "onUpdate:selectedEntities", "unselectedEntities", "onUpdate:unselectedEntities", "onSelectionChangeManual", "onRefreshPage", "onReloadTable"])), [
                        [_vShow, !_ctx.querystore.isLoading || _ctx.keepLiteTableVisibleOnLoading]
                      ])
                    : _createCommentVNode("", true),
                  (
                !_ctx.querystore.isLoading &&
                _ctx.querystore.getCurrentGraph &&
                (_ctx.querystore.getCurrentGraph.CurveResults ||
                  _ctx.querystore.getCurrentGraph.BarChartResults ||
                  _ctx.querystore.getCurrentGraph.PieChartResults)
              )
                    ? (_openBlock(), _createBlock(_component_query_chart, {
                        key: 5,
                        modelValue: _ctx.querystore.getCurrentGraph,
                        "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.querystore.getCurrentGraph) = $event)),
                        "src-element": {
                ChartId: _ctx.genstore.selectedItem.Id,
                ChartType:
                  _ctx.genstore.selectedItem.elType === 2
                    ? 0
                    : _ctx.genstore.selectedItem.elType === 3
                    ? 1
                    : 2,
                Destination: _ctx.genstore.selectedItem.DestType,
              },
                        onRefreshChart: _ctx.getQueryResult
                      }, null, 8, ["modelValue", "src-element", "onRefreshChart"]))
                    : _createCommentVNode("", true),
                  (_ctx.querystore.getCurrentReport)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.querystore.getCurrentReport, (report, rep_index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: 'ri_' + rep_index
                          }, [
                            ([0, 1, 6].includes((report as QueryResultItem).elementType) && 
                    (report as QueryResultItem).Element && 
                    ((report as QueryResultItem).Element as AnalyticsResultTableExtended).HeaderRow)
                              ? (_openBlock(), _createBlock(_component_query_table_preview, {
                                  key: 0,
                                  modelValue: _ctx.querystore.getCurrentReport[rep_index],
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.querystore.getCurrentReport[rep_index]) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true),
                            ([2, 3, 4].includes((report as QueryResultItem).elementType) && 
                    (report as QueryResultItem).Element && 
                    (((report as QueryResultItem).Element as any).CurveResults || 
                    ((report as QueryResultItem).Element as any).BarChartResults || 
                    ((report as QueryResultItem).Element as any)))
                              ? (_openBlock(), _createBlock(_component_query_chart_preview, {
                                  key: 1,
                                  modelValue: _ctx.querystore.getCurrentReport[rep_index],
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.querystore.getCurrentReport[rep_index]) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                              : _createCommentVNode("", true),
                            ([901].includes((report as QueryResultItem).elementType) && (report as QueryResultItem).elementItem)
                              ? (_openBlock(), _createBlock(_component_report_break_preview, {
                                  key: 2,
                                  "input-text": ((report as QueryResultItem).elementItem as BaseListItem).Name || ''
                                }, null, 8, ["input-text"]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ], 6)
              ], 4)
            ]),
            _: 1
          }, 8, ["modelValue", "class", "onUpdate:modelValue"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.$t("no_access")), 1))
    ]),
    _: 1
  }, 8, ["class", "onKeydown"]))
}